import { lineIconBase, type LineIconProps } from '@/shared/ui/icons/base';

/**
 * Authoring shell for a hand-authored line icon (Register A). Spread {...lineIconBase}, pass the paths as
 * children. Decorative unless a `title` is given (then role="img" + a rendered <title>). See ./base.ts and
 * docs/brand/iconography.md §2. Example:
 *
 *   export function FooIcon(props: LineIconProps) {
 *     return <LineIcon {...props}><path d="…" /></LineIcon>;
 *   }
 */
export function LineIcon({
  size = 24,
  className,
  title,
  children,
}: LineIconProps & { children: React.ReactNode }): React.ReactElement {
  return (
    <svg
      {...lineIconBase}
      width={size}
      height={size}
      className={className}
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
    >
      {title ? <title>{title}</title> : null}
      {children}
    </svg>
  );
}
